import { render, staticRenderFns } from "./afterSales.vue?vue&type=template&id=16c5173c&scoped=true&"
import script from "./afterSales.vue?vue&type=script&lang=js&"
export * from "./afterSales.vue?vue&type=script&lang=js&"
import style0 from "./afterSales.vue?vue&type=style&index=0&id=16c5173c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5173c",
  null
  
)

export default component.exports